import React, { Component } from "reactn";
import PropTypes from "prop-types";
import classNames from "classnames";
import isConnected from "js/core/utilities/isConnected";
import { getStaticUrl, isElectron } from "js/config";
import { app } from "js/namespaces";
import { ds } from "js/core/models/dataService";
import "css/menu-sidebar.scss";
import { FlexSpacer } from "js/react/components/Gap";
import { BlueButton } from "js/react/components/UiComponents";
import { Fragment } from "react";

const NavigationBar = ({
    navItems,
    selectedPaneId,
    selectedSecondaryId,
    showLogout,
    isElectron,
    isConnected
}) => {
    const handleLogOutClicked = () => {
        ds.shutdown();
        window.location = "/logout";
    };

    const renderNavItem = option => (
        <div
            className={classNames({
                [`nav-item`]: true,
                [`selected`]: selectedPaneId === option.id,
                ["back-button-item"]: option.id === "back",
                ["is-in-tour"]: !!app.tour && option.id === "back"
            })}
            onClick={() => {
                option.handleClick && option.handleClick();
            }}
            key={`nav-item-${option.id}`}
        >
            <span className="title">{option.html || option.title}</span>
            {option.secondaryItems && option.id === selectedPaneId && (
                <div className="secondary-items">
                    {createSecondaryItems(option.secondaryItems)}
                </div>
            )}
            {option.id === "back" && (
                <img src={getStaticUrl("/images/backIcon.svg")} />
            )}
        </div>
    );

    const createNavItems = () =>
        navItems
            .filter(item => item.id !== "back")
            .map(option => renderNavItem(option));

    const createSecondaryItems = items =>
        items.map(secondaryItem => {
            return (
                <div
                    className={classNames({
                        ["nav-item"]: true,
                        ["secondary-item"]: true
                    })}
                    onClick={e => {
                        secondaryItem.handleClick(e);
                    }}
                    key={`nav-item-secondary-${secondaryItem.id}`}
                >
                    <span
                        className={classNames({
                            ["secondary-title"]: true,
                            ["selected"]:
                                selectedSecondaryId === secondaryItem.id
                        })}
                    >
                        {secondaryItem.html || secondaryItem.title}
                    </span>
                </div>
            );
        });

    return (
        <div className="menu-sidebar animate-in">
            {renderNavItem(navItems.find(item => item.id === "back"))}
            <div className="sidebar-items">{createNavItems()}</div>
            {showLogout && (
                <Fragment>
                    <FlexSpacer />
                    <BlueButton
                        style={{ width: "100%", minWidth: 250 }}
                        disabled={isElectron && !isConnected.connected}
                        onClick={() => handleLogOutClicked()}
                    >
                        Log Out
                    </BlueButton>
                </Fragment>
            )}
        </div>
    );
};

NavigationBar.propTypes = {
    navItems: PropTypes.array.isRequired,
    selectedPaneId: PropTypes.string,
    selectedSecondaryId: PropTypes.string,
    showLogout: PropTypes.bool
};

const injectProps = WrappedComponent => {
    return class WrappedNavigationBar extends Component {
        state = {
            isElectron,
            isConnected
        };

        componentDidMount() {
            isConnected.on("change", () => {
                this.setState({ isConnected });
            });
        }

        render() {
            return <WrappedComponent {...this.state} {...this.props} />;
        }
    };
};

export default injectProps(NavigationBar);
